import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import LoginForm from './Login';
import App from './App';


const Loadfirsts = () => {
  return (
    <Router>
      <div className="app-container">
        <LoginForm />
      </div>
    </Router>
  );
};
export default Loadfirsts;


 

